import type { AxiosResponse } from 'axios';

import request from '@app/utils/request';

import type { ExportData } from './types';
import prepareIntermediaryDownloadFormDataObject from './utils/prepareIntermediaryDownloadFormDataObject';

export enum AppError {
    invalidCall = '404',
    customError = '4040',
    missingToken = '5001',
    invalidToken = '5002',
    invalidApp = '5003',
    invalidParameter = '5010',
    notSupported = '5099',
}

export type PostDownloadFileResponse = {
    err: '0' | '1';
    file: string | '_error';
};

export type PostDownloadErrorResponse = {
    response: {
        code: AppError;
        message: string;
        status: 'error';
    };
};

export const isPostDownloadErrorResponse = (
    data: PostDownloadFileResponse | PostDownloadErrorResponse,
): data is PostDownloadErrorResponse => (data as PostDownloadErrorResponse)?.response?.status === 'error';

export type PostDownloadResponse = AxiosResponse<PostDownloadFileResponse | PostDownloadErrorResponse>;

export const postDownload = (data: ExportData): Promise<PostDownloadResponse> => {
    const formData = new FormData();

    Object.entries(prepareIntermediaryDownloadFormDataObject(data)).forEach(([key, value]) => {
        formData.append(key, value);
    });

    return request({
        method: 'POST',
        url: '/ajax',
        data: formData,
    });
};
